var exports = {
  "R": "xf0b3b88a--e7922d--preloader",
};

module.exports = exports;
